import { render, staticRenderFns } from "./tabNotification.vue?vue&type=template&id=a7111486"
import script from "./tabNotification.vue?vue&type=script&lang=js"
export * from "./tabNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports